import { mapState, mapGetters, mapActions } from 'vuex';
import AcademicMainType from '@/helpers/academicMainType';
import CategoryType from '@/helpers/contentCategory';
import ContentType from '@/helpers/contentType';
import TeachersList from '@/components/content-v2/modals/teachers-list';
import CommonMixin from '@/mixins/templates/common';
import { TemplateName } from '@/helpers/templateType';

import { ABtn } from "@maisaedu/ui-components-a-btn";
import { AInput } from "@maisaedu/ui-components-a-input";
import ContentSyncMixin from '@/mixins/content-sync';

export default {
  props: {
    showLogo: {
      type    : Boolean,
      default : false
    },
    showAcademicMainName: {
      type    : Boolean,
      default : false
    },
    isOpenNavigationDrawer: {
      type    : Boolean,
      default : false
    }
  },
  components: {
    TeachersList,
    ABtn,
    AInput
  },
  mixins: [CommonMixin, ContentSyncMixin],
  data() {
    return {
      TemplateName,
      ContentType,
      hasINDBlackWhite   : false,
      isEditingTitle     : false,
      isTeachersListOpen : false,
      cannotRenameTopic  : false,

      contentOptionsStudent: [
        {
          text            : 'content.layout.timeline.render.options.academicSupport',
          icon            : 'mdi-school-outline',
          func            : () => this.openTeachersListModal(),
          permissionAlias : '',
          hideInComunity  : false,
          hideInLTI       : true
        },
        {
          text : 'content.layout.timeline.render.options.gradeGrid',
          icon : 'mdi-file-table-box-outline',
          func : () =>
            this.$router.push(
              `/my-grades/${this.getterContent.context.academicMainId}`
            ),
          permissionAlias : '',
          hideInComunity  : true,
          hideInLTI       : false
        }
      ]
    };
  },
  computed: {
    ...mapState({
      logoLight   : (state) => state._core.application.logo.light,
      logoDark    : (state) => state._core.application.logo.dark,
      isLtiAccess : (state) => state.plataforma.user.isLtiAccess
    }),
    ...mapGetters({
      getterUserRoleContext : 'plataforma/user/getterUserContext',
      getterContent         : 'plataforma/newContent/getterContent'
    }),
    getToolbarIcon() {
      if (this.getterContent.topics && Array.isArray(this.getterContent.topics)) {
        if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
          return 'mdi-menu';
        } else {
          return 'mdi-arrow-left';
        }
      } else {
        return 'mdi-arrow-left';
      }
    },
    logo() {
      return (this.$vuetify.theme.dark || this.hasINDBlackWhite) ? this.logoDark : this.logoLight;
    },
    showEditButtonObject() {
      return this.getterContent.context && this.getterContent.context.categoryTypeId && this.getterContent.context.categoryTypeId !== CategoryType.ORGANIZATION && !this.getterUserRoleContext.isStudent;
    },
    contentOptions() {
      return [
        {
          text            : 'content.contentTypePage.editContent',
          icon            : 'mdi-pencil-outline',
          func            : () => this.editObjectAlone(),
          permissionAlias : 'edit',
          isHidden        : this.$vuetify.breakpoint.mdAndUp || this.isAssociatedCourse
        },
        {
          text            : 'content.contentTypePage.configure',
          icon            : 'mdi-cog-outline',
          func            : () => this.editPage(),
          permissionAlias : 'resources_page_configure',
          isHidden        : this.isAssociatedCourse || this.getterContent.context && this.getterContent.context.categoryTypeId && this.getterContent.context.categoryTypeId !== CategoryType.ORGANIZATION
        },
        {
          text            : 'classPage.printContent',
          icon            : 'mdi-printer',
          func            : () => this.$nuxt.$emit('changeIsOpenModalPrintContent'),
          permissionAlias : ''
        },
        {
          text            : 'classPage.reportProblemModalLabel',
          icon            : 'mdi-alert-outline',
          func            : () => this.$nuxt.$emit('changeIsOpenModalReportProblem'),
          permissionAlias : 'report_problem',
          isHidden        : this.getterContent.context && !this.getterContent.context.isMarketplace
        }
      ].filter((option) => !option.isHidden);
    },
    computedContentOptionsStudent() {
      if (this.getterContent.context?.academicMainTypeId === AcademicMainType.COMMUNITY) {
        return this.contentOptionsStudent.filter(option => !option.hideInComunity);
      }

      if (this.isLtiAccess) {
        return this.contentOptionsStudent.filter(option => !option.hideInLTI);
      }

      return this.contentOptionsStudent;
    }
  },
  mounted() {
    this.observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        this.$nextTick(() => {
          this.onClassChange(m.target.getAttribute(m.attributeName));
        });
      }
    });

    this.observer.observe(document.body, {
      attributes      : true,
      attributeFilter : ['class']
    });

    this.onClassChange(document.body.className);
  },
  methods: {
    ...mapActions({
      actionPatchTitleTopic: 'plataforma/newContent/actionPatchTitleTopic'
    }),
    onClassChange(classList) {
      if (classList?.includes('INDblackwhite')) {
        this.hasINDBlackWhite = true;
      } else {
        this.hasINDBlackWhite = false;
      }
    },
    actionToolbarButton() {
      if (this.getterContent.topics && Array.isArray(this.getterContent.topics)) {
        if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
          this.$emit('isOpenDrawer', !this.isOpenNavigationDrawer);
        } else {
          this.$router.push(`/course/${this.$route.params.courseId}`);
        }
      } else {
        this.$router.push(`/course/${this.$route.params.courseId}`);
      }
    },
    academicMainTypeName() {
      return AcademicMainType.getName(this.getterContent.context && this.getterContent.context.academicMainTypeId);
    },
    changeTopicTitle(onBlur = false) {
      if (onBlur && (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm)) {
        return false;
      }

      const params = {
        topicId        : this.getterContent.context.topicId,
        academicMainId : this.$route.params.courseId,
        title          : this.$refs.topicTitle.$el.querySelector('input').value,
        version        : this.getterContent.context.version
      };

      this.$nuxt.$loading.start();

      this.actionPatchTitleTopic(params)
        .then(() => {
          this.toggleEditingTitle();
          this.$toast.success(this.$t('content.successMessagesSnackbar.changeTitle'));
        }).catch((err) => {
          this.$toast.error(err.data.error.message);
        }).finally(() => {
          this.$nuxt.$loading.finish();
        });
    },
    toggleEditingTitle() {
      this.isEditingTitle = !this.isEditingTitle;
    },
    editObjectAlone() {
      const params = {
        academicMainId     : this.getterContent.context.academicMainId,
        academicMainTypeId : this.getterContent.context.academicMainTypeId,
        topicId            : this.getterContent.context.topicId,
        version            : this.getterContent.context.version,
        isEditing          : true
      };

      const openEditModal = CategoryType.getEditModalEventById(this.getterContent.context.categoryTypeId);
      this.$nuxt.$emit(openEditModal, params);
    },
    editPage() {
      const params = {
        topicId            : this.getterContent.context.topicId,
        academicMainTypeId : this.getterContent.context.academicMainTypeId,
        version            : this.getterContent.context.version,
        academicMainId     : this.getterContent.context.academicMainId,
        isEditing          : true
      };

      this.$nuxt.$emit('changeIsOpenModalContentPage', params);
    },
    onRemovedRenameButton() {
      this.cannotRenameTopic = true;
    },
    openTeachersListModal() {
      this.isTeachersListOpen = true;
    }
  },
  beforeDestroy() {
    this.observer?.disconnect();
  }
};
